<template>
  <jump-to-nav
    class="laptop:position-sticky-top laptop:padding-top-2xl"
    title="On This Page"
  >
    <list>
      <list-item hash="#account">Account Terms</list-item>
      <list-item hash="#cancelation">Cancelation &amp; Termination</list-item>
      <list-item hash="#modifications">Modifications to the Service</list-item>
      <list-item hash="#copyright">Copyright and Content Ownership</list-item>
      <list-item hash="#general">General Conditions</list-item>
    </list>
  </jump-to-nav>
</template>
<script>
  import JumpToNav from 'app/components-wa/nav/JumpToNav'
  import JumpToNavList from 'app/components-wa/nav/JumpToNavList'
  import JumpToNavListItem from 'app/components-wa/nav/JumpToNavListItem'

  export default {
    name: 'InPageNav',

    components: {
      JumpToNav,
      List: JumpToNavList,
      ListItem: JumpToNavListItem
    }
  }
</script>
